import ErrorIcon from '@mui/icons-material/Error';
import { Row, RowItem } from 'blocks/CommonLayout';
import Card from 'components/Card';
import { WarnBoxProps } from './warnBox.interface';
import * as S from './wranbox.styles';

const WarnBox = ({ text }: WarnBoxProps) => (
  <S.Wrapper>
    <Card space="small">
      <Row>
        <S.WarnBoxSvg as={ErrorIcon} />
        <RowItem>
          <S.WarnBoxSpan>{text}</S.WarnBoxSpan>
        </RowItem>
      </Row>
    </Card>
  </S.Wrapper>
);

export default WarnBox;
